import { useState } from "react";
import style from "./ProxySettings.module.scss";
import cn from "classnames";
import { AutoRenewal, ChangingIP, ChangingPassword, Export, Operator } from "./components";
import { IProxy } from "@interfaces/user/proxy";
import { TariffExtension } from "./components/TariffExtension/TariffExtension";

export function ProxySettings({
    exportTab,
    operator,
    changingIP,
    autoRenewal,
    changingPassword,
    tariffExtension,
    data,
    isOpen
}: {
    exportTab?: boolean,
    operator?: boolean,
    changingIP?: boolean,
    autoRenewal?: boolean,
    changingPassword?: boolean,
    tariffExtension?: boolean,
    data: IProxy,
    isOpen: boolean
}) {
    const [activeTab, setActiveTab] = useState<"export" | "operator" | "changingIP" | "autoRenewal" | "changingPassword" | "tariffExtension">("operator")

    return (
        <div className={style.container}>
            <div className={style.tabsNavigate}>
                {exportTab && <button
                    className={cn(style.button, activeTab === "export" && style.button_active)}
                    onClick={() => setActiveTab("export")}>
                    Експорт
                </button>}
                {operator && <button
                    className={cn(style.button, activeTab === "operator" && style.button_active)}
                    onClick={() => setActiveTab("operator")}>
                    Оператор
                </button>}
                {changingIP && <button
                    className={cn(style.button, activeTab === "changingIP" && style.button_active)}
                    onClick={() => setActiveTab("changingIP")}>
                    Зміна ір
                </button>}
                {autoRenewal && <button
                    className={cn(style.button, activeTab === "autoRenewal" && style.button_active)}
                    onClick={() => setActiveTab("autoRenewal")}>
                    Автопродовження
                </button>}
                {changingPassword && <button
                    className={cn(style.button, activeTab === "changingPassword" && style.button_active)}
                    onClick={() => setActiveTab("changingPassword")}>
                    Пароль
                </button>}
                {tariffExtension && <button
                    className={cn(style.button, activeTab === "tariffExtension" && style.button_active)}
                    onClick={() => setActiveTab("tariffExtension")}>
                    Продовжити термін дії
                </button>}
            </div>
            {
                isOpen ?
                    <>
                        {
                            activeTab === "export"
                                ? <Export />
                                : null
                        }
                        {
                            activeTab === "operator"
                                ? <Operator data={data} />
                                : null
                        }
                        {
                            activeTab === "changingIP"
                                ? <ChangingIP data={data} />
                                : null
                        }
                        {
                            activeTab === "autoRenewal"
                                ? <AutoRenewal />
                                : null
                        }
                        {
                            activeTab === "changingPassword"
                                ? <ChangingPassword data={data}/>
                                : null
                        }
                        {
                            activeTab === "tariffExtension"
                                ? <TariffExtension data={data}/>
                                : null
                        }
                    </>
                    : null
            }
        </div>
    )
}